<template>
  <div class="page-content refunds">
    <div class="row">
      <div class="col-sm-6 col-12">
        <refund-deposit />
      </div>
      <div class="col-sm-6 col-12">
        <refund-go-go-credits />
        <remove-go-go-credits />
      </div>
      <div class="col-12">
        <add-free-ride-credits />
        <grant-supervisor-retention-offer />
        <refund-ride-cost />
        <refund-custom-charge />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { nextTick, onMounted, defineAsyncComponent } from 'vue';
import { useRoute } from 'vue-router';

import util from '@/Utils/util';

const AddFreeRideCredits = defineAsyncComponent(() => import('./Refunds/AddFreeRideCredits.vue') as any);
const GrantSupervisorRetentionOffer = defineAsyncComponent(() => import('./Refunds/GrantSupervisorRetentionOffer.vue') as any);
const RefundDeposit = defineAsyncComponent(() => import('./Refunds/RefundDeposit.vue') as any);
const RefundCustomCharge = defineAsyncComponent(() => import('./Refunds/RefundCustomCharge.vue') as any);
const RefundGoGoCredits = defineAsyncComponent(() => import('./Refunds/RefundGoGoCredits.vue') as any);
const RefundRideCost = defineAsyncComponent(() => import('./Refunds/RefundRideCost.vue') as any);
const RemoveGoGoCredits = defineAsyncComponent(() => import('./Refunds/RemoveGoGoCredits.vue') as any);

onMounted(async () => {
  const route = useRoute();
  const { hash } = route;

  await nextTick();
  util.moveScrollComponent(hash);
});
</script>
